import { SET_FAILED_MESSAGE, SET_PAYOUT_LIST, SET_SUCCESS_MESSAGE } from "./types";
import advisorService from '../services/advisor.service'

export const getPayoutListAction = (page, limit, search, status, companyId='') => async (dispatch) => {
    return await advisorService.getPayoutList(page, limit, search, status, companyId).then(async (resp) => {
        if (resp.status) {
            dispatch({ type: SET_PAYOUT_LIST, payload: resp?.data, count: resp?.count });
        } else {
            dispatch({ type: SET_PAYOUT_LIST, payload: {} });
        }
        return resp;
    });
};

export const payToAdvisorAction = (page, limit, search, status) => async (dispatch) => {
    return await advisorService.paytoAdvisor(page, limit, search, status).then(async (resp) => {
        if (resp.status) {
            await dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data || resp.message });
        } else {
            await dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data || resp.message });
        }
        dispatch(getPayoutListAction(1, 20, "", ""))
        return resp;
    });
};